import moment from 'moment'
import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { TicketSize } from '../../types'
import ActionTypes from './actionTypes'
import { ArrayUtils, ObjectUtils } from '../../utils'

type TicketSizeCreateRequest = {
    type: typeof ActionTypes.TICKET_SIZE_CREATE_REQUEST;
    payload: never;
}

type TicketSizeCreateFailure = {
    type: typeof ActionTypes.TICKET_SIZE_CREATE_FAILURE;
    payload: Error;
}

type TicketSizeCreateSuccess = {
    type: typeof ActionTypes.TICKET_SIZE_CREATE_SUCCESS;
    payload: TicketSize;
}

export type TicketSizeCreation = Omit<TicketSize, 'id'>

const CreateTicketSizeFields = [
    'size',
    'start_date',
    'end_date',
    'skus',
    'storecodes',
] as const

const sanitizeArrayToCSV = (v: unknown) => {
    if (!Array.isArray(v)) return ''
    return ArrayUtils.cleanStringArray(v)
}

function createTicketSize(ticketSize: TicketSizeCreation) {
    const body = ObjectUtils.copy(ticketSize, CreateTicketSizeFields, {
        start_date: (v: Date) => moment(v).format('YYYY-MM-DD'),
        end_date: (v: Date) => moment(v).format('YYYY-MM-DD'),
        skus: sanitizeArrayToCSV,
        storecodes: sanitizeArrayToCSV,
    })

    return createAction<RootState, TicketSize, never>({
        endpoint: `${HUBBLE_API_TOKEN}/ticket-sizes`,
        method: 'POST',
        body: JSON.stringify(body),
        types: [
            ActionTypes.TICKET_SIZE_CREATE_REQUEST,
            ActionTypes.TICKET_SIZE_CREATE_SUCCESS,
            ActionTypes.TICKET_SIZE_CREATE_FAILURE,
        ],
    })
}

export type TicketSizeCreateAction = TicketSizeCreateRequest
    | TicketSizeCreateFailure
    | TicketSizeCreateSuccess

export default createTicketSize
